import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class Tag extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.

  static modelName = 'Tag'
  // Define default properties here
  static instanceDefaults () {
    return {
      tag: null,
      localeId: 1,
      standardActionId: null,
    }
  }
}
const servicePath = 'tags'
const servicePlugin = makeServicePlugin({
  Model: Tag,
  service: feathersClient.service(servicePath),
  servicePath,
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
})

export default servicePlugin
